import { WithChildrenCommonProps } from '@shipengine/giger';
import { stepContentStyles } from './StepContentStyles';

export const StepContent = (props: WithChildrenCommonProps<unknown>): JSX.Element => {
    const { children } = props;

    return <section css={stepContentStyles}>{children}</section>;
};
